import { VideoPropertiesServiceOutput } from './VideoPropertiesServiceOutput';
export class VideoPropertiesService {
    static instance;
    output;
    static getInstance() {
        if (!VideoPropertiesService.instance) {
            VideoPropertiesService.instance = new VideoPropertiesService();
        }
        return VideoPropertiesService.instance;
    }
    static getNotificationInterface() {
        return VideoPropertiesService.getInstance();
    }
    static getOutput() {
        return VideoPropertiesServiceOutput.getReactiveOutput();
    }
    async init() { }
    constructor() {
        this.output = new VideoPropertiesServiceOutput();
    }
    notifyVideoPropertiesChanged(videoProperties) {
        this.output.setVideoProperties(videoProperties);
    }
}
